import { close, STEPS } from 'components/QuestionnaireRequestAutomated/processor/slices/interstitialSlice'
import Drawer from 'components/utility/drawer'
import React, { Fragment, useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ConfirmCloseModal from '../../modal/confirmCloseModal'
import { getFormInstance, updateActiveSection } from '../../slices/formInstanceSlice'
import Fields from './Fields'
import Sign from './Sign'
import Edit from './Edit'

function InterstitialContent(props) {
  const { step, initialAttachments } = props

  switch (step) {
    case STEPS.sign:
      return <Sign />
    case STEPS.edit:
      return <Edit />
    default:
      return <Fields initialAttachments={initialAttachments} />
  }
}

function ProcessInterstitial(props) {
  const dispatch = useDispatch()
  const [openCloseModal, setOpenCloseModal] = useState(false)
  const { show, step } = useSelector((state) => state.interstitial)
  const formInstanceId = useSelector((state) => state.global.formInstanceId)

  const onClose = useCallback(() => setOpenCloseModal(true), [])
  const onInterstitialClose = useCallback(() => {
    dispatch(updateActiveSection(0))
    dispatch(getFormInstance(formInstanceId))
    setOpenCloseModal(false)
    dispatch(close())
  }, [dispatch, formInstanceId])

  return (
    <Fragment>
      <Drawer show={show} onClose={onClose}>
        <Drawer.Content direction="bottom">
          <div style={{ height: 'calc(100vh - 50px)' }}>
            <InterstitialContent step={step} initialAttachments={props.initialAttachments} />
          </div>
        </Drawer.Content>
      </Drawer>
      <ConfirmCloseModal
        open={openCloseModal}
        onSubmit={onInterstitialClose}
        onClose={() => setOpenCloseModal(false)}
      />
    </Fragment>
  )
}

export default ProcessInterstitial
